const globalCourseAliases = import.meta.env.VITE_GLOBAL_COURSE_ALIASES as string
export const GLOBAL_COURSE_CODE_NAMES: Record<string, string> = globalCourseAliases.split(',').reduce(
    (acc: Record<string, string>, alias: string) => {
        const [code, name] = alias.split(':')
        acc[code] = name
        return acc
    },
    {} as Record<string, string>,
)
